export type PaginationInfo = {
  pageInfo: {
    count: number
  }
}

export type DateRange = {
  from: Date
  to: Date
}

export const EmployeeLocale = {
  es_ES: "es_ES",
  en_US: "en_US",
} as const

export const FrequencyEnum = {
  None: "None",
  Once: "Once",
  Weekly: "Weekly",
  Monthly: "Monthly",
} as const

export type Frequency = (typeof FrequencyEnum)[keyof typeof FrequencyEnum]

export const SentimentEnum = {
  VeryPositive: "VeryPositive",
  Positive: "Positive",
  Neutral: "Neutral",
  Negative: "Negative",
  VeryNegative: "VeryNegative",
} as const

export const ExtendedSentimentEnum = {
  ...SentimentEnum,
  NeutralN: "NeutralN",
  NeutralP: "NeutralP",
} as const

export type Sentiment = keyof typeof SentimentEnum
export type ExtendedSentiment = keyof typeof ExtendedSentimentEnum

export const SENTIMENTS: {
  label: string
  range: [number, number]
  value: ExtendedSentiment
  color: string
}[] = [
  {
    label: "shared.sentiments.veryNegative",
    range: [0, 0.7],
    value: SentimentEnum.VeryNegative,
    color: "negative",
  },
  {
    label: "shared.sentiments.negative",
    range: [0.7, 1.5],
    value: SentimentEnum.Negative,
    color: "negative-soft",
  },
  {
    label: "shared.sentiments.neutral",
    range: [1.5, 2.5],
    value: SentimentEnum.Neutral,
    color: "neutral",
  },
  {
    label: "shared.sentiments.positive",
    range: [2.5, 3.3],
    value: SentimentEnum.Positive,
    color: "positive-soft",
  },
  {
    label: "shared.sentiments.veryPositive",
    range: [3.3, 4],
    value: SentimentEnum.VeryPositive,
    color: "positive",
  },
  {
    label: "",
    range: [1.5, 2],
    value: ExtendedSentimentEnum.NeutralN,
    color: "neutral",
  },
  {
    label: "",
    range: [2, 2.5],
    value: ExtendedSentimentEnum.NeutralP,
    color: "neutral",
  },
]

export const getSentimentThreshold = (sentiment: Sentiment) => {
  const threshold = SENTIMENTS.find((s) => s.value === sentiment)?.range[1]
  if (!threshold) throw new Error("Sentiment threshold not found")
  return threshold
}

export const getSentimentValue = (sentiment: number) => {
  if (sentiment === 4) return SentimentEnum.VeryPositive

  const sentimentValue = SENTIMENTS.find(
    (s) => sentiment >= s.range[0] && sentiment < s.range[1],
  )?.value
  if (!sentimentValue) throw new Error("Sentiment value not found")
  return sentimentValue
}
